export default "__VITE_ASSET__D1f$3Ygq__"